export const DESKTOP_QUERY = "(min-width: 768px)";
export const RECENT_QUOTES_LS = "rec_quo_ls";